import CACA1120RequestModel from '@/api/data/CAC/CACG1120/CACA1120RequestModel'
import CACA1120ResponseModel from '@/api/data/CAC/CACG1120/CACA1120ResponseModel'

import RestService from '@/common/RestService'
import ApiUrlConstants from '@/common/ApiUrlConstants'

export default class CACG1120Service {
  /**
   * @param productNo
   * @param shhnCd
   * @returns CACA1120ResponseModel
   */
  public async callAPICACA1120(
    productNo,
    shhnCd
  ): Promise<CACA1120ResponseModel> {
    const caca1120RequestModel = new CACA1120RequestModel()
    caca1120RequestModel.productNo = productNo
    caca1120RequestModel.shhnCd = shhnCd
    const caca1120ResponseModel: CACA1120ResponseModel = <
      CACA1120ResponseModel
    > await RestService.post(ApiUrlConstants.CACA1120, caca1120RequestModel)
    return caca1120ResponseModel
  }
}
